const getService = (context, name) => {
    const service = context.services && context.services[name]

    if (typeof service !== 'function') {
        throw new Error(`Similar Reply Requests requires services.${name}()`)
    }

    return service
}

const createSimilarReplyRequestsController = ({
    context,
    setLoading,
    publishEffect,
    completeExternalStep,
}) => Object.freeze({
    flush() {
        return Promise.resolve()
    },
    async handleAction(action) {
        if (action.type === 'similar-reply-requests.select') {
            const candidateIds = context.bulkReplyCandidates.candidates.map(candidate => candidate.requestId)
            context.bulkReplyCandidates.selectedRequestIds = (action.payload.requestIds || [])
                .filter(id => candidateIds.includes(id))
            return context.bulkReplyCandidates.selectedRequestIds
        }

        if (action.type !== 'similar-reply-requests.retry') {
            throw new Error(`Unsupported Similar Reply Requests action "${action.type}"`)
        }

        setLoading(true)
        try {
            const state = await getService(context, 'refreshBulkReplyCandidates')({ force: true })

            if (state.error === null && state.candidates.length === 0) {
                await completeExternalStep({ isValid: true, errors: [] })
            }

            await publishEffect({
                type: 'request.bulk-reply-candidates.changed',
                phase: 'committed',
                scopes: ['request.bulk-reply-candidates'],
            })

            return state
        } finally {
            setLoading(false)
        }
    },
})

export { createSimilarReplyRequestsController }
export default createSimilarReplyRequestsController
